import { MenuDownIcon, MenuUpIcon } from '@atgfr8/icons';
import { For, Show } from 'solid-js';

import { SelectInputCustom } from './SelectInputCustom';
import './Styles.css';

export type SelectInputFilledMenuItem = {
  label: string;
  value: string;
  disabled?: boolean;
  hidden?: boolean;
  title?: string;
};

export type SelectInputFilledProps = {
  label?: string;
  menuItems: SelectInputFilledMenuItem[];
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  name?: string;
  disabled?: boolean;
  error?: string | null;
  required?: boolean;
  dataTestId: string;
  backgroundColor?: string;
  customSelectInput?: boolean;
};

export const SelectInputFilled = (props: SelectInputFilledProps) => {
  const hasError = () => Boolean(props.error);
  const hasValue = () =>
    props.value !== undefined && props.value !== '' && !props.disabled;

  const shellBackground = (): string => {
    if (props.backgroundColor !== undefined) return props.backgroundColor;
    if (props.disabled) return '#f3f4f6';
    return '#ffffff';
  };

  return (
    <div class="relative w-full min-w-0">
      <div
        class={`select-input-filled-shell relative rounded-[4px] flex flex-col gap-0 px-3 pt-1 pb-1 min-w-0 w-full shadow-xs outline-none ${
          hasError() && !props.disabled ? 'ring-2 ring-error-red' : 'ring-0'
        }`}
        style={{
          '--select-shell-bg': shellBackground(),
        }}
      >
        <Show when={props.label}>
          <label
            class={`text-xs font-medium leading-none pointer-events-none ${
              hasError() ? 'text-error-red' : 'text-armstrong-primary'
            }`}
          >
            {props.label}
          </label>
        </Show>
        <Show when={props.menuItems} keyed>
          <div class="w-full min-w-0">
            <Show
              when={props.customSelectInput === false}
              fallback={
                <SelectInputCustom
                  dataTestId={props.dataTestId}
                  name={props.name}
                  required={props.required}
                  menuItems={props.menuItems.filter((item) => !item.hidden)}
                  value={props.value ?? ''}
                  placeholder={props.placeholder}
                  onChange={(value) => props.onChange?.(value)}
                  disabled={props.disabled}
                  error={props.error}
                  iconColor={props.disabled ? '#9ca3af' : '#757575'}
                  menuClass="py-1! border border-[#d4d4d4] rounded-[10px]! bg-[rgba(246,246,246,0.96)]! shadow-[0_8px_24px_rgba(0,0,0,0.18)]! backdrop-blur-[20px]"
                  menuItemClass="gap-1.5! mx-1! px-2! py-0.5! rounded-[4px]! bg-transparent! text-[#1f1f1f]! text-[16px] leading-5 font-medium! antialiased transition-none! before:content-['✓'] before:invisible aria-selected:before:visible not-aria-disabled:hover:bg-[#349af6]! not-aria-disabled:hover:text-white! not-aria-disabled:[&.select-input-custom-option--active]:bg-[#349af6]! not-aria-disabled:[&.select-input-custom-option--active]:text-white!"
                  class="-mx-3 w-[calc(100%+1.5rem)]! h-auto! py-0! border-0! shadow-none! rounded-none! bg-transparent!"
                />
              }
            >
              <select
                data-testid={props.dataTestId}
                name={props.name}
                required={props.required ?? false}
                aria-invalid={hasError() || undefined}
                value={props.value ?? ''}
                onChange={(e) => props.onChange?.(e.currentTarget.value)}
                disabled={props.disabled}
                class={`select-input select-input--filled peer -mx-3 w-[calc(100%+1.5rem)] appearance-none pl-3 pr-10 py-0 min-h-0 border-0 shadow-none rounded-none ring-0 outline-none focus:outline-none focus-visible:ring-0 disabled:opacity-70
           ${props.disabled ? 'select-input-disabled' : 'cursor-pointer'}
           ${hasValue() ? 'select-input-has-value' : ''}
           `}
              >
                <Show when={props.placeholder}>
                  <option
                    value=""
                    style={{ 'background-color': 'var(--select-shell-bg)' }}
                  >
                    {props.placeholder ?? '-'}
                  </option>
                </Show>
                <For each={props.menuItems}>
                  {(item) => (
                    <option
                      value={item.value}
                      disabled={item.disabled}
                      hidden={item.hidden}
                      title={item.title}
                    >
                      {item.label}
                    </option>
                  )}
                </For>
              </select>
              <MenuDownIcon
                size="18px"
                color={props.disabled ? '#9ca3af' : '#757575'}
                class="select-input-icon select-input-icon--down right-3"
              />
              <MenuUpIcon
                size="18px"
                color={props.disabled ? '#9ca3af' : '#757575'}
                class="select-input-icon select-input-icon--up right-3"
              />
            </Show>
          </div>
        </Show>
      </div>
      {hasError() && (
        <div class="text-error-red text-xs mt-0.5 px-2">{props.error}</div>
      )}
    </div>
  );
};
